import { BaseError } from './base';

export class ClientAlreadyInitializedError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'client_already_initialized_error',
      docsUrl: null,
      name: 'ClientAlreadyInitializedError',
      shortMessage: 'Client must not be initialized more than once',
    });
  }
}
